<template lang="pug">
  .power-scale
    .power-scale__indicator
      transition(name="power-scale", mode="out-in")
        .power-scale__points(
          v-for="item in powerStates",
          v-if="item === scaleState",
          :class="'power-scale__points_' + item",
          :style="'height: ' + pointsHeight + 'px;'")
    .power-scale__polygon-cont
      .power-scale__polygon
        .power-scale__icon
      transition(name="power-scale", mode="out-in")
        .power-scale__polygon-state(
          v-for="item in powerStates",
          v-if="item === scaleState",
          :class="'power-scale__polygon-state_' + item")
</template>

<script>
const SCALE_POINTS_NUMBER = 12;
const SCALE_POINT_HEIGHT = 27;
let pointWeight;

export default {
  name: 'PowerScale',
  props: ['count', 'maxValue'],
  mounted() {
    pointWeight = this.maxValue / SCALE_POINTS_NUMBER;
  },
  computed: {
    scaleState() {
      let state = 'green';

      if (this.count <= SCALE_POINTS_NUMBER + 1) { // 1 - animation fix
        state = 'red';
      } else if (this.count <= (2 * SCALE_POINTS_NUMBER) + 1) { // 1 - animation fix
        state = 'yellow';
      }

      return state;
    },
    pointsHeight() {
      let points = 1;

      if (this.count <= 1) {
        points = 0;
      } else if (this.count > pointWeight) {
        points = Math.round(this.count / pointWeight);
      }

      return SCALE_POINT_HEIGHT * points;
    },
  },
  data() {
    return {
      scaleHeight: 0,
      powerStates: ['green', 'yellow', 'red'],
    };
  },
};
</script>

<style lang="scss">
  $point-width: 16px;
  $point-height: 27px;
  $stateItems:
    (green, '~@/assets/interface__points_green.png', $interface-power-polygon-green-group, $interface-power-polygon-green-xs-group),
    (yellow, '~@/assets/interface__points_yellow.png', $interface-power-polygon-yellow-group, $interface-power-polygon-yellow-xs-group),
    (red, '~@/assets/interface__points_red.png', $interface-power-polygon-red-group, $interface-power-polygon-red-xs-group);
  .power {
    &-scale {
      @include vertical-align;
      flex-direction: column;
      @include vue-trans;
      &__indicator {
        position: relative;
        display: flex;
        justify-content: center;
        @include retina-sprite($interface-power-scale-group);
        @media (max-width: $max-width-xs),
          (-moz-touch-enabled: 1),
          (pointer: coarse) {
          transform: scaleY(.7);
        }
      }
      &__points {
        position: absolute;
        bottom: 7px;
        left: 6px;
        width: $point-width;
        height: 0;
        @each $name, $pointImg, $stateSprite, $stateSpriteXs in $stateItems {
          &_#{$name} {
            background: url($pointImg) repeat-y left bottom;
            background-size: $point-width $point-height;
          }
        }
      }
      &__polygon {
        z-index: z('default') + 1;
        position: relative;
        @include vertical-align;
        justify-content: center;
        @include retina-sprite($interface-power-polygon-group);
        @media (max-width: $max-width-xs) {
          @include retina-sprite($interface-power-polygon-xs-group);
        }
        &-cont {
          position: relative;
          margin-top: -19px;
          @include vertical-align;
          @media (-moz-touch-enabled: 1),
            (pointer: coarse) {
            margin-top: -62px;
          }
          @media (max-width: $max-width-xs) {
            margin-top: -64px;
          }
        }
        &-state {
          z-index: z('default');
          position: absolute;
          @each $name, $pointImg, $stateSprite, $stateSpriteXs in $stateItems {
            &_#{$name} {
              @include retina-sprite($stateSprite);
              @media (max-width: $max-width-xs) {
                @include retina-sprite($stateSpriteXs);
              }
            }
          }
        }
      }
      &__icon {
        @include retina-sprite($interface-power-group);
        @media (max-width: $max-width-xs) {
          @include retina-sprite($interface-power-xs-group);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/PowerScale.vue